import { IconCircleCheck, IconCircleX } from "@tabler/icons-react";
import type { FC, ReactNode } from "react";

interface HintValidInvalidProps {
    title?: string;
    text?: ReactNode;
    invalid?: string;
    valid?: string;
}

export const HintValidInvalid: FC<HintValidInvalidProps> = ({
    title,
    text,
    invalid,
    valid,
}) => (
    <div>
        {title && <h4 className="font-semibold text-small">{title}</h4>}
        {text && <p className="whitespace-pre-line text-sm">{text}</p>}
        {(invalid || valid) && (
            <div className="mt-2 flex flex-col gap-2">
                {invalid && (
                    <div className="flex gap-2 whitespace-pre-line text-danger-600">
                        <IconCircleX
                            stroke={1.5}
                            size={20}
                            className="shrink-0"
                        />
                        {invalid}
                    </div>
                )}
                {valid && (
                    <div className="flex gap-2 whitespace-pre-line text-success-600">
                        <IconCircleCheck
                            stroke={1.5}
                            size={20}
                            className="shrink-0"
                        />
                        {valid}
                    </div>
                )}
            </div>
        )}
    </div>
);
